interface DailyEnv {
  apiBase: string;
  appsyncUrl: string;
  appsyncRealtimeUrl: string;
  appsyncRegion: string;
  cognitoUserPoolId: string;
  cognitoClientId: string;
  householdId: string;
  domain: string;
  mock: boolean;
}

export const env: DailyEnv = {
  apiBase: import.meta.env.VITE_API_BASE ?? '',
  appsyncUrl: import.meta.env.VITE_APPSYNC_URL ?? '',
  appsyncRealtimeUrl: import.meta.env.VITE_APPSYNC_REALTIME_URL ?? '',
  appsyncRegion: import.meta.env.VITE_APPSYNC_REGION ?? 'eu-west-2',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
  householdId: import.meta.env.VITE_HOUSEHOLD_ID ?? 'duncan',
  domain: import.meta.env.VITE_DOMAIN ?? 'daily.tiramiistu.me',
  mock:
    !import.meta.env.VITE_API_BASE ||
    import.meta.env.VITE_USE_MOCK === '1',
};
